import ReactMarkdown from 'react-markdown'
import { Box } from 'theme-ui'
import styles from './styles'

type MarkdownContentProps = {
  layout: string
}

const components = {
  strong: (props: object) => <Box as="span" sx={styles.bold} {...props} />,
}

const MarkdownContent = ({ layout }: MarkdownContentProps) => {
  return (
    <Box sx={styles.container}>
      <ReactMarkdown components={components} children={layout} />
    </Box>
  )
}

export default MarkdownContent
